import React from "react";

type ErrorBoundaryProps = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

type State = {
  hasError: boolean;
  error: Error | null;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, State> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("🧨 ErrorBoundary caught:", error, info);

    // опционально: отправка на сервер
    fetch("/api/log-error", {
      method: "POST",
      body: JSON.stringify({
        message: error.message,
        stack: error.stack,
        info,
      }),
      headers: { "Content-Type": "application/json" },
    }).catch(console.warn);
  }

  render() {
    const { hasError, error } = this.state;
    const { fallback } = this.props;

    if (hasError) {
      if (fallback) return fallback;

      // стандартный fallback
      return (
        <div style={{ padding: "2rem", color: "#fff", textAlign: "center" }}>
          <h2>Что-то пошло не так 😔</h2>
          <p>{error?.message}</p>
          <button onClick={() => window.location.reload()}>Перезагрузить</button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
